module.exports = __webpack_public_path__ + "static/media/notification.df2ec125.svg";